import { Tooltip } from "@mui/material";
import { Close } from "@mui/icons-material";
import BillData from "./BillData";
import TrueFalseImage from "../../../components/TrueFalseImage";
import { useNavigate } from "react-router-dom";

export default function BillIcon({ item }) {
  const navigate = useNavigate();

  const showBill = () => {
    window.open(`/bills/${item?.Bill?.Id}`, "_blank");
  };

  return (
    <div>
      {item.Bill ? (
        <Tooltip title={<BillData billModel={item.Bill} />}>
          <button
            onClick={item.Bill.Billed ? showBill : undefined}
          >
            {item.Bill.Billed ? (
              <TrueFalseImage value />
            ) : (
              <Close style={{ color: "red" }} />
            )}
          </button>
        </Tooltip>
      ) : (
        <TrueFalseImage iconColor="gray" />
      )}
    </div>
  );
}
